import { useEffect, useId, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import lodash from "lodash";
import axios from "axios";
import Cookies from "js-cookie";
import { utils } from "../utils";
import { COMN_CODE } from "../constants";
import { useTheme, getResourceKey } from "../hooks";
import { resourceState } from "../features/recoil";
import { _TEST1234 } from "../features/config/ApiConfig";
import { useResourceContext } from "../features/context/ResourceContext";

export type TOption = {
    label: string;
    value: string;
};

export type UseOptionsProps = {
    async?: boolean;
    area?: string;
    comnCd?: string;
    options?: TOption[];
    excludes?: string[];
    includes?: TOption[];
    filter?: (arg?: any) => boolean;
    asyncParams?: any;
};

type UseOptionsReturn = {
    base: string;
    data: any[];
    options: TOption[];
    hasOption: boolean;
    valueKey: any;
    labelKey: any;
    asyncCode: any;
    status: any;
};

export const useOptions = (props: UseOptionsProps): UseOptionsReturn => {
    const { async, area, comnCd, options, excludes, includes, filter, asyncParams } = props;

    const base = useId();

    const { theme } = useTheme();
    const [resource] = useRecoilState(resourceState);
    // const { getResourceByValue } = useResourceContext();

    const resourceKey = area ? getResourceKey(area, comnCd, theme.lang) : null;
    const valueKey = (area && COMN_CODE[area]?.value) || null;
    const labelKey = (area && COMN_CODE[area]?.label) || null;

    const dataRef = useRef([]);

    const [_status, _setStatus] = useState("loading");

    const [_options, _setOptions] = useState(() => {
        if (options) return options;
        if (!async && area) {
            if (COMN_CODE[area]) {
                const key = getResourceKey(area, comnCd, theme.lang);
                const _ = resource[key];
                if (_) {
                    dataRef.current = _.value;
                    return _.value.map((code: any) => ({
                        label: utils.getCodeLabel(area, code),
                        value: utils.getCodeValue(area, code),
                    }));
                }
            }
        }
        return [];
    });

    useEffect(() => {
        if (!Boolean(options)) {
            if (!async && area) {
                if (COMN_CODE[area]) {
                    const key = getResourceKey(area, comnCd, theme.lang);
                    const _ = resource[key];
                    if (_) {
                        dataRef.current = _.value;
                        _setOptions(
                            _.value.map((code: any) => ({
                                label: utils.getCodeLabel(area, code),
                                value: utils.getCodeValue(area, code),
                            })),
                        );
                    }
                }
            }
        }
    }, [Boolean(options), resource, resourceKey, async]);

    const asyncCode = async (value: any) => {
        // console.log("!!");

        // const a = await getResourceByValue(area, value, asyncParams);
        // console.log(a);
        // return;

        if (!area) return;
        // State variable for Excel Functions
        _setStatus("loading");
        // No option
        const code = COMN_CODE[area];
        if (!area || !value || !code || !code.async || !code.path2 || value.length < code.path2MinLength) {
            _setStatus("done");
            _setOptions([]);
            return;
        }
        const getCode = async (value: any) => {
            const base = process.env.REACT_APP_API_OSCI;
            const path = code.path2;
            const query = (path.indexOf("?") === -1 ? "?" : "&") + `${code.value}=${value}`;
            const url = base + path + query;
            try {
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${_TEST1234.AUTHORIZATION}`,
                        "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN",
                    },
                    params: utils.toGetParams(asyncParams),
                });
                const options =
                    response.data[Object.keys(response.data)[0]].content?.map?.((code: any) => ({
                        label: code[labelKey],
                        value: code[valueKey],
                    })) || [];
                _setStatus("done");
                _setOptions(options);
            } catch (error) {
                _setStatus("done");
                _setOptions([]);
                console.log(error);
            }
        };
        getCode(value);
    };

    let $a = _options;
    if (Array.isArray(options)) {
        $a = options;
    }
    if (excludes) {
        if (Array.isArray(excludes)) {
            $a = $a.filter((item: any) => {
                return lodash.indexOf(excludes, item.value) === -1;
            });
        }
        if (excludes instanceof Function) {
            $a = dataRef.current
                .filter((item: any) => {
                    return !excludes(item);
                })
                .map((code: any) => ({
                    label: utils.getCodeLabel(area, code),
                    value: utils.getCodeValue(area, code),
                }));
        }
    }
    if (includes) {
        $a = $a.concat(includes);
    }
    if (filter) {
        $a = $a.filter((item: any) => {
            return filter(item);
        });
    }

    return {
        base,
        options: $a,
        hasOption: $a.length > 0,
        data: dataRef.current,
        valueKey,
        labelKey,
        asyncCode,
        status: _status,
    };
};
